import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useState } from "react";
import {
  createGrowthGoals as createGrowthGoalsService,
  updateGrowthGoals as updateGrowthGoalsService,
  deleteGrowthGoals as deleteGrowthGoalsService,
} from "../../services/developmental-rubrics/growth-goals.service.js";

import {
  updateDevelopmentalRubricFormField,
} from "../../store/actions/developmental-rubrics.actions.js";
import { handlerErrorV2 } from "../../utils/errors.jsx";
import { toggleAlertModule } from "../../store/actions/alert.actions";


const useGrowthGoals = () => {
  const { curriculumId, id } = useParams();

  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const growthGoals = useSelector((state) => state?.dr?.form?.growthGoals || [])

  const onUpdateFormData = (data, type) => {
    if (type === 'create') {
      const newQuestion = {
        _id: data._id || new Date().getTime(),
        id: data._id || new Date().getTime(),
        question: data.question
      }
      dispatch(updateDevelopmentalRubricFormField('growthGoals', [...growthGoals, newQuestion]))
    } else if (type === 'edit') {
      const newFormData = growthGoals
        .map((item) => ({ ...item, _id: item._id || item.id }))
        .map((item) => {
        if (String(item._id) === String(data._id)) {
          return {
            ...item,
            question: data.question
          }
        }
        return item
      })
      dispatch(updateDevelopmentalRubricFormField('growthGoals', newFormData))
    } else if (type === 'delete') {
      const newFormData = growthGoals.map((item) => ({ ...item, _id: item._id || item.id }))
        .filter((item) => String(item._id) !== String(data._id))
      dispatch(updateDevelopmentalRubricFormField('growthGoals', newFormData))
    }
  }

  const formData = (form) => {
    return {
      question: form.question
    }
  };
  const createGrowthGoals = async (form = {}) => {
    try {
      const data = formData(form);
      const response = await createGrowthGoalsService(
        curriculumId,
        id,
        data
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        onUpdateFormData(response.data, 'create')
        enqueueSnackbar("Developmental rubric updated successfully", {
          variant: "success",
        });
        dispatch(toggleAlertModule());

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    }
  };

  const updateGrowthGoals = async (weId, form = {}) => {
    try {
      const data = formData(form);
      const response = await updateGrowthGoalsService(
        curriculumId,
        id,
        weId,
        data
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        onUpdateFormData(response.data, 'edit')
        enqueueSnackbar("Developmental rubric updated successfully", {
          variant: "success",
        });
        dispatch(toggleAlertModule());

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    }
  };

  const deleteGrowthGoals = async (weId) => {
    setIsLoading(true);
    try {
      const response = await deleteGrowthGoalsService(
        curriculumId,
        id,
        weId
      );
      if (!response.data && response.error) {
        return {
          error: true,
          message: response.error.message || "An error ocurred",
        };
      } else {
        onUpdateFormData({ _id: weId }, 'delete')
        enqueueSnackbar("Developmental rubric updated successfully", {
          variant: "success",
        });

        return { error: false };
      }
    } catch (error) {
      const message = handlerErrorV2(error);
      return { error: true, message };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    createGrowthGoals,
    updateGrowthGoals,
    deleteGrowthGoals,
  };
};

export default useGrowthGoals;
